/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chatbot_medium'
export default icon
